import "../models/appointment_grid_date.js";
import "../../../utilities/iso_date.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotPickerModal ??= {};
window.AppointmentBooking.SlotPickerModal.Collections ??= {};

AppointmentBooking.SlotPickerModal.Collections.AppointmentGridDates = class AppointmentGridDates extends (
  Backbone.Collection
) {
  constructor() {
    super(...arguments);
    this.between = this.between.bind(this);
    this.for = this.for.bind(this);
    this.getSlot = this.getSlot.bind(this);
  }

  // API

  between(startDate, endDate) {
    return this.filter((appointmentGridDate) => moment(appointmentGridDate.date).isBetween(startDate, endDate));
  }

  for(date) {
    const id = Sparkle.Utilities.isoDate(moment(date));
    return this.get(id) || new this.model({ date: id });
  }

  getSlot(slotId) {
    let slot = null;
    this.find((date) => (slot = _.find(date.get("slots"), { id: slotId })));

    return slot;
  }
};
AppointmentBooking.SlotPickerModal.Collections.AppointmentGridDates.prototype.model =
  AppointmentBooking.SlotPickerModal.Models.AppointmentGridDate;
AppointmentBooking.SlotPickerModal.Collections.AppointmentGridDates.prototype.comparator = "date";
